import { getSocket } from "../../utilities/socketService";

export const subscribeToChat = ({
  onMessage,
  onUpdated,
  onMatched,
  onConnect,
}) => {
  let attached = null;
  let intervalId = null;

  const attach = (socket) => {
    attached = socket;
    if (onMessage) socket.on("eventChat:message", onMessage);
    if (onUpdated) socket.on("eventChat:updated", onUpdated);
    if (onMatched) socket.on("eventChat:matched", onMatched);
    if (onConnect) socket.on("connect", onConnect);
  };

  const existing = getSocket();
  if (existing) {
    attach(existing);
  } else {
    intervalId = setInterval(() => {
      const socket = getSocket();
      if (socket) {
        attach(socket);
        clearInterval(intervalId);
        intervalId = null;
      }
    }, 1000);
  }

  return () => {
    if (intervalId) clearInterval(intervalId);
    if (!attached) return;
    if (onMessage) attached.off("eventChat:message", onMessage);
    if (onUpdated) attached.off("eventChat:updated", onUpdated);
    if (onMatched) attached.off("eventChat:matched", onMatched);
    if (onConnect) attached.off("connect", onConnect);
  };
};
